import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { PATHS } from "@/lib/router";
import { useAuthStore } from "@/features/auth/hooks";
import { Can } from "@/hooks/useCan/Can";
const SurveysFormHeader = ({
  submitting,
  label,
  //disabled = false,
}) => {
  const { t } = useTran();
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const permissions = user?.permissions || [];

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <Button
        type="button"
        variant="ghost"
        onClick={() => navigate(PATHS.SURVEY_LIBRARY)}
        className="flex items-center gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        {t("Back to Survey Library")}
      </Button>
      <Can
        resource="survey_library"
        action="create"
        userPermissions={permissions}
      >
        <Button
          type="submit"
          disabled={submitting} // || disabled
        >
          {submitting ? t("Saving…") : (label ?? t("Save Survey"))}
        </Button>
      </Can>
    </div>
  );
};

export default SurveysFormHeader;
